<script>

import countriesCodes from '../../assets/json/countriesCodes.json'

export default {
  inject: ['$_'],
  name: "mobileNumberInput",
  props: {
    phoneContact: Object,
    countryPrefixError: Boolean,
    phoneNumberError: Boolean,
    countryName: String,
    textDataName: String,
    inputsDisabled: Boolean
  },
  data() {
    let vm = this;
    return {
      allCountries: vm.$_.sortBy(countriesCodes, ['countryCode']),
      phoneNumberData: {
        phoneNumberDigits: '',
        countryPrefixDigits: ''
      }
    }
  },
  methods: {
    decimalNumbersAllowed(event) {
      let charCode = (event.which) ? event.which : event.keyCode;
      if ((charCode >= 48 && charCode <= 57) || charCode === 46 || charCode === 8 || charCode === 127 || charCode === 190) {
        return true;
      } else {
        event.preventDefault();
      }
    },
    titleCase(str) {
      return str.toLowerCase().replace(/\b\w/g, s => s.toUpperCase());
    }
  },
  watch: {
    phoneNumberData: {
      handler(newValue) {
        let vm = this;
        vm.$emit('phoneNumberProvided', newValue);
      },
      deep: true
    },
    phoneContact: {
      handler(newValue) {
        let vm = this;
        if (vm.$_.trim(newValue.phoneNumberPrefix) !== '') {
          vm.phoneNumberData.countryPrefixDigits = newValue.phoneNumberPrefix;
        } else {
          vm.$_.forEach(vm.allCountries, function (countryData) {
            if (vm.$_.trim(countryData.Country).toLowerCase() === vm.$_.trim(vm.countryName).toLowerCase()) {
              vm.phoneNumberData.countryPrefixDigits = countryData.countryCode;
            }
          });
        }
        if (vm.$_.trim(newValue.phoneNumber) !== '') {
          vm.phoneNumberData.phoneNumberDigits = newValue.phoneNumber;
        }
      },
      deep: true
    }
  },
  mounted() {
    let vm = this;
    if (vm.$_.trim(vm.phoneContact.phoneNumberPrefix) !== '') {
      vm.phoneNumberData.countryPrefixDigits = vm.phoneContact.phoneNumberPrefix;
      if (vm.$_.trim(vm.phoneContact.phoneNumber) !== '') {
        vm.phoneNumberData.phoneNumberDigits = vm.phoneContact.phoneNumber;
      }
      vm.$emit('phoneNumberProvided', vm.phoneNumberData);
    } else {
      vm.$_.forEach(vm.allCountries, function (countryData) {
        if (vm.$_.trim(countryData.Country).toLowerCase() === vm.$_.trim(vm.countryName).toLowerCase()) {
          vm.phoneNumberData.countryPrefixDigits = countryData.countryCode;
          if (vm.$_.trim(vm.phoneContact.phoneNumber) !== '') {
            vm.phoneNumberData.phoneNumberDigits = vm.phoneContact.phoneNumber;
          }
          vm.$emit('phoneNumberProvided', vm.phoneNumberData);
        }
      });
    }
  }
}
</script>

<template>
  <div>
    <div class="field has-addons">
      <p class="control">
                <span class="select">
                  <select v-bind:disabled="inputsDisabled" v-model="phoneNumberData.countryPrefixDigits"
                          v-bind:class="{'error-input':countryPrefixError}">>
                    <option value="">Select One</option>
                   <option v-for="(countryData, index) in allCountries" v-bind:value="countryData.countryCode"
                           v-bind:key="index">
+{{ countryData.countryCode }}
                   </option>
                  </select>
                </span>
      </p>
      <p class="control is-expanded has-icons-left">
        <input v-bind:disabled="inputsDisabled" class="input input-no-margin-top" type="number"
               v-bind:placeholder="textDataName"
               v-bind:class="{'error-input':phoneNumberError}"
               v-model.number="phoneNumberData.phoneNumberDigits"
               v-on:keydown="decimalNumbersAllowed">
        <span class="icon is-small is-left">
          <font-awesome-icon :icon="['fas', 'mobile']"/>
        </span>
      </p>
    </div>
  </div>
</template>

<style scoped>

.error-input {
  border: 1px solid red !important;
  background-color: #ffefef !important;
}

</style>